var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 15.8541H14.3667C13.7 15.8541 13.0667 16.1125 12.6 16.5791L11.175 17.9875C10.525 18.6291 9.46668 18.6291 8.81668 17.9875L7.39166 16.5791C6.925 16.1125 6.28333 15.8541 5.625 15.8541H5C3.61667 15.8541 2.5 14.7458 2.5 13.3792V4.28748C2.5 2.92081 3.61667 1.8125 5 1.8125H15C16.3833 1.8125 17.5 2.92081 17.5 4.28748V13.3792C17.5 14.7375 16.3833 15.8541 15 15.8541Z",
    fill: "#6F00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 8.813C11.0726 8.813 11.942 7.94372 11.942 6.87137C11.942 5.79902 11.0726 4.92969 10.0003 4.92969C8.92792 4.92969 8.05859 5.79902 8.05859 6.87137C8.05859 7.94372 8.92792 8.813 10.0003 8.813Z",
    fill: "#6F00FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2336 12.6893C12.9086 12.6893 13.3003 11.9393 12.9253 11.381C12.3586 10.5393 11.2586 9.97266 10.0003 9.97266C8.74197 9.97266 7.64196 10.5393 7.0753 11.381C6.7003 11.9393 7.09198 12.6893 7.76698 12.6893H12.2336Z",
    fill: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTag);
export default __webpack_public_path__ + "static/media/user-tag.a07eb768eeae125ae506fef19244db12.svg";
export { ForwardRef as ReactComponent };